import useIntervalPicker from "./hooks/useIntervalPicker";
import IntervalView from "./view";

/**
 * DatePicker.Interval — anchored popup for selecting a date range.
 *
 * Imperative API via `controlRef`:
 *   controlRef.current.open(anchorEl, { presetId?, from?, to? })
 *   controlRef.current.close()
 *
 * Props:
 *   controlRef  — ref handle for open/close
 *   value       — { presetId?, from, to } current external selection
 *   presets     — optional override of the suggestions list
 *   minDate     — optional lower bound
 *   maxDate     — optional upper bound
 *   onApply     — ({ presetId, from, to }) => void
 *   onCancel    — () => void
 */
export default function Interval(props) {
    const state = useIntervalPicker(props);
    return <IntervalView {...state} />;
}
